import React from 'react';
import { GenericOption, GenericSelect, SearchInput } from 'com-gyf-webcore-userinterfacecomponents';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

/**
 * Componente encargado de generar el encabezado de la distribucion de limites - tarjetas
 */
const TableHeader = (props) =>
{

    let { empresaId, limiteCompraEmpresa, cuentaTarjetaId, limiteCompraCuenta, permisos, data, cambiarEmpresa, cambiarCuenta, limitesCliente } = props;

    const limiteCompraEmpresaFormateado = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompraEmpresa);
    const limiteCompracuentaFormateado = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompraCuenta);

    let empresas = data != undefined ? data.empresas : undefined
    let cuentas = data != undefined ? data.cuentas : undefined
    let limiteCliente = data != undefined ? data.limiteCliente : undefined
    let nodosEmpresas = [];
    let nodosCuentas = [];

    if (cuentas.length > 0) {
        cuentas = cuentas.filter(x => x.EmpresaVisaId == empresaId);
    }

    const crearOptionsEmpresas = (empresa, index) => {
        return (<option value={empresa.Id} key={"empresa-option" + index}>{empresa.Descripcion + " (" + empresa.tipoCuentaDescripcion + ")"}</option>);
    }

    const crearOptionsCuentas = (cuenta, index) => {
        return (<option value={cuenta.Id} key={"cuenta-option" + index}>{cuenta.Descripcion}</option>);
    }

    if (data.functions.Confidencial == true) {

        nodosEmpresas = [];
        if (empresas != undefined){ 
            nodosEmpresas = empresas.map((emp2, index) => {
                return crearOptionsEmpresas(emp2, index);
            });
        }

        nodosCuentas = [];
        if (cuentas != undefined) {
            nodosCuentas = cuentas.map((cue2, index) => {
                return crearOptionsCuentas(cue2, index);
            });
        }
    }
    else {
        nodosEmpresas = empresas.filter((emp1) => emp1.EsConfidencial == false).map((emp2, index) => {
            return crearOptionsEmpresas(emp2, index);
        });

        nodosCuentas = cuentas.filter((cue1) => cue1.EsConfidencial == false).map((cue2, index) => {
            return crearOptionsCuentas(cu2, index);
        });
    }

    let limiteClienteFormato = GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimitePorCuit);

    return (
    <div>
        <div className="row">
            <div className="col-md-8">
                <label className="label-secondary">Límite global para {data.selectedAdministrator}:</label>
            </div>
            <div className="col-md-4">
                <label className="label-secondary">${limiteClienteFormato}</label>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="col-md-1">
                </div>
                <div className="col-md-3 no-padding-right">
                    <label className="label-secondary">Límite de</label>
                </div>
                <div className="col-md-8 no-padding-left">
                    <select value={empresaId} className="form-control default-select bottom-separator-xs" onChange={cambiarEmpresa}>
                        {nodosEmpresas}
                    </select>
                </div>
            </div>
            <div className="col-md-2"></div>
            <div className="col-md-4">
                <label className="label-secondary">${limiteCompraEmpresaFormateado}</label>
            </div>
        </div>
        {nodosCuentas.length == 0
            ? <div className="row">
                <div className="col-md-2">
                </div>
                <div className="col-md-10">
                    <label className="label-primary">Aun no existen cuentas y tarjetas para ésta empresa</label>
                </div>
            </div>
            : <div className="row">
                <div className="col-md-7">
                    <div className="col-md-2">
                    </div>
                    <div className="col-md-2 no-padding-right">
                        <label className="label-secondary">Límite de</label>
                    </div>
                    <div className="col-md-8 no-padding-left">
                        <select value={cuentaTarjetaId} className="form-control default-select bottom-separator-xs" onChange={cambiarCuenta}>
                            {nodosCuentas}
                        </select>
                    </div>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-4">
                    <label className="label-secondary color-black">${limiteCompracuentaFormateado}</label>
                </div>
            </div>}
    </div>
    );
}

export default TableHeader;